import { defineStore } from "pinia";
import axiosInstance from "../config/axios";

export const useShopStore = defineStore("shop", {
    state: () => {
        return {
            cities: [],
            formattedShops: [],
            selectedShop: null,
            selectedShopId: null,
            shop: null,
            shops: [],
            source: "",
        };
    },
    getters: {
        getShops(state) {
            let uniqueCountries = state.formattedShops && state.formattedShops.map((shop) => shop.country_name);
            uniqueCountries = uniqueCountries?.filter(
                (uniqueCountry, index) => uniqueCountries.indexOf(uniqueCountry) === index
            );

            uniqueCountries = uniqueCountries?.map((uniqueCountry) => ({
                country: uniqueCountry,
                items: state.formattedShops.filter((shop) => shop.country_name === uniqueCountry),
            }));

            return uniqueCountries ? uniqueCountries : [];
        },
    },
    actions: {
        fetchShops() {
            return axiosInstance.get("/v1/home/shops").then((response) => {
                this.shops = response.data;
                this.formattedShops = response.data;
            });
        },
        fetchUserShops(userId) {
            return axiosInstance.get(`/v1/home/users/${userId}/shops`).then((response) => {
                this.shops = response.data;
                this.formattedShops = response.data;
            });
        },

        filterFormattedShops(inputText) {
            this.formattedShops = [...this.shops];
            this.formattedShops = this.formattedShops.filter((shop) =>
                shop.name.toLowerCase().includes(inputText.toLowerCase())
            );
        },
        async fetchCities(countryId) {
            return axiosInstance.get(`/v1/home/cities/${countryId}`).then((response) => {
                this.cities = response.data;
            });
        },
    },
});
